import React, { useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import API from '../../../services/API'
import { Button, Grid, Stack, Typography } from '@mui/material'
import QuickActionCard from '../../../components/Cards/QuickActionCard'
import StatusCard from '../../../components/Cards/StatusCard'
import NumberCard from '../../../components/Cards/NumberCard'
import NumberCardTwo from '../../../components/Cards/NumberCardTwo'
import SmsIcon from '@mui/icons-material/Sms'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'
import ActionButton from '../../../components/Buttons/ActionButton'
import { useLocation, useNavigate } from 'react-router-dom'
import SmallModal from '../../../components/Modals/SmallModal'
import { DetailRow } from '../../../components/Cards/DetailsBox'
import SMSPopup from './SMSPopup'

const SMSHistory = () => {
  const [loadingCredits, setLoadingCredits] = useState(true)
  const [remainingCredits, setRemainingCredits] = useState(0)
  const [loadingSMSLogs, setLoadingSMSLogs] = useState(true)
  const [smsLogs, setSMSLogs] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(50)
  const [total, setTotal] = useState(0)
  const [selectedSMS, setSelectedSMS] = useState(null)

  function useQuery() {
    const { search } = useLocation()
    return useMemo(() => new URLSearchParams(search), [search])
  }
  const navigate = useNavigate()
  const query = useQuery()

  useEffect(() => {
    const checkCredits = async () => {
      await API.get('/settings?select=smsCredits')
        .then((res) => {
          if (res.status === 200) {
            const currentCredits = res.data.smsCredits
            setRemainingCredits(currentCredits)
            setLoadingCredits(false)
          }
        })
        .catch((err) => console.error('Failed to fetch smsCredits:', err))
        .finally(() => setLoadingCredits(false))
    }

    checkCredits()
  }, [query])

  const getSMS = () => {
    setLoadingSMSLogs(true)
    API.get(`/sms-history?page=${page}&pageSize=${pageSize}`)
      .then((res) => {
        if (res.status === 200) {
          setSMSLogs(res.data.records)
          setTotal(res.data.total)
        }
      })
      .finally(() => setLoadingSMSLogs(false))
  }
  useEffect(() => {
    getSMS()
  }, [page, pageSize])

  return (
    <Stack gap={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={4}>
          <Typography variant="title2">SMS History</Typography>
        </Grid>
        <Grid item xs={12} lg={4}></Grid>
        <StatusCard
          number={remainingCredits}
          label="Credits Remaining"
          icon={SmsIcon}
          color={1}
          loading={loadingCredits}
          button="Buy More"
          onClick={() => navigate('/sms-credits')}
        />
      </Grid>
      <CustomDataGrid
        loading={loadingSMSLogs}
        rows={smsLogs}
        columns={[
          {
            field: 'createdAt',
            headerName: 'Date',
            minWidth: 150,
            renderCell: ({ row }) =>
              moment(row.createdAt).format('DD/MM/YYYY HH:mm'),
          },
          {
            field: 'toUser',
            valueGetter: (value) => value._id,
            renderCell: ({ row }) =>
              row.toUser.firstName + ' ' + row.toUser.lastName,
            minWidth: 200,
            flex: 1,
            headerName: 'To',
          },
          {
            field: 'message',
            headerName: 'Message',
            minWidth: 200,
            flex: 1,
            cellClassName: 'wrap-text-sms',
          },
          { field: 'toNumber', headerName: 'Number', minWidth: 200 },
          { field: 'creditsUsed', headerName: 'Credits', minWidth: 120 },
        ]}
        onRowClick={({ row }) => setSelectedSMS(row)}
        getRowId={(row) => row._id}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        rowCount={total}
        pagination
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        paginationMode="server"
      />
      <SMSPopup selectedSMS={selectedSMS} setSelectedSMS={setSelectedSMS} />
    </Stack>
  )
}

export default SMSHistory
